import { licenseActionMenuKeys } from "../../../../../constants/LicenseManagement.constants";

export const DROPDOWN_CONFIG = {
  WIDTH: 160,
  GAP: -8,
  PADDING: 8,
  ESTIMATED_HEIGHT: 180,
};

export const DISABLED_ACTION_IDS = [
  licenseActionMenuKeys.RENEW_LICENSE,
  licenseActionMenuKeys.TERMINATE_LICENSE,
];
